import { OsTypes } from '../webview/types'
// hack to override window type checking due to weird object checks here
declare const window

export enum MobileDevice {
  Android = 'Android',
  iOS = 'iOS',
  WindowsPhone = 'Windows Phone',
  Unknown = 'unknown',
}

/* tslint:disable-next-line:variable-name */
export const getMobileDevice = (_window = window) => {
  const userAgent =
    _window.navigator.userAgent || _window.navigator.vendor || _window.opera

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone'
  }

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (
    /iOSDasherWebView|iPad|iPhone|iPod/.test(userAgent) &&
    !_window.MSStream
  ) {
    return 'iOS'
  }

  return 'unknown'
}

/**
 * Used to detect the webview OS from the user agent
 * Used for webviews in the Dasher apps
 */
export function detectWebviewOs() {
  const userAgent = window.navigator.userAgent

  if (/iOSDasherWebView/.test(userAgent)) {
    return OsTypes.iOS
  }

  if (/AndroidDasherWebView/.test(userAgent)) {
    return OsTypes.Android
  }

  return OsTypes.NONE
}

export function isWebview() {
  return detectWebviewOs() !== OsTypes.NONE
}

export const getIsMobile = (_window = window) => {
  return getMobileDevice(_window) !== 'unknown'
}

export const getDeviceVersion = (_window = window) => {
  const userAgent = _window.navigator.userAgent
  const os = detectWebviewOs()

  if (os === OsTypes.Android) return userAgent.split('client-version:')[1]

  if (os === OsTypes.iOS) {
    /* 
      We only want to return x.x.x, ios sometimes has versions that are x.x.x.x.x.x
      which are generally related to build data but is not supported with semver cmp
    */
    const clientVersion = userAgent.split('client-version: ')[1]
    const versionArray = clientVersion.split(/\./g)
    versionArray.length = 3
    return versionArray.join('.')
  }
}
